import React from 'react';
import SaleItemNav from './sale-item-nav';
/**
 * 個別のナビ生成
 */
const createNavElement = (type, url, itemNumber, endOfSale, gaPrefix) => {
    return (React.createElement(SaleItemNav, { type: type, url: url, key: type, endOfSale: endOfSale, gaPrefix: gaPrefix, itemNumber: itemNumber }));
};
/**
 * ナビゲーションの生成
 */
const createNavElements = (saleItem, gaPrefix) => {
    const result = [];
    if (saleItem.url_ps4) {
        result.push(createNavElement('ps4', saleItem.url_ps4, saleItem.image_name, saleItem.eos_ps4, gaPrefix));
    }
    if (saleItem.url_ps5) {
        result.push(createNavElement('ps5', saleItem.url_ps5, saleItem.image_name, saleItem.eos_ps5, gaPrefix));
    }
    if (saleItem.url_ns) {
        result.push(createNavElement('ns', saleItem.url_ns, saleItem.image_name, saleItem.eos_ns, gaPrefix));
    }
    if (saleItem.url_3ds) {
        result.push(createNavElement('ds', saleItem.url_3ds, saleItem.image_name, saleItem.eos_3ds, gaPrefix));
    }
    return result;
};
const SaleItemNavBar = ({ saleItem, gaPrefix }) => {
    return (React.createElement("div", { className: "sale-item-navbar" }, createNavElements(saleItem, gaPrefix)));
};
export default SaleItemNavBar;
